module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 1_Skills_Bars-Horizontal.fbcbe24d.svg";